import request from '../utils/request'

const api = {
  getCaptcha: '/getCaptcha',
  reg: '/reg',
  sendCode:'/sendCodePro'
}

export default api

export const sendCode = (parameter) => {
  return request({
    url: api.sendCode,
    method: 'post',
    data: parameter
  })
}

export const getCaptcha = (parameter) => {
  return request({
    url: api.getCaptcha,
    method: 'post',
    data: parameter
  })
}

export const reg = (parameter) => {
  return request({
    url: api.reg,
    method: 'post',
    data: parameter
  })
}


 